export const CAN_CREATE_ANY_TEMPLATE = 'can_create_any_template';
